import { boot } from 'quasar/wrappers'
import type { VueQueryPluginOptions } from '@tanstack/vue-query'
import { QueryCache, QueryClient, VueQueryPlugin } from '@tanstack/vue-query'
import { fail } from 'src/utils/notify'

export const queryClient = new QueryClient({
  queryCache: new QueryCache({
    onError: (error: any, query) => {
      if (error?.response?.status === 401) {
        return
      }

      if (query.meta?.errorMessage) {
        fail(
          error?.response?.data?.message
            ? error?.response?.data?.message
            : error.message,
        )
      } else {
        fail(error.response?.data?.message as string)
      }
    },
  }),
})

export default boot(({ app }) => {
  const vueQueryPluginOptions: VueQueryPluginOptions = {
    queryClient,
    enableDevtoolsV6Plugin: process.env.ENV !== 'PROD',
  }

  app.use(VueQueryPlugin, vueQueryPluginOptions)
})
